import React, { useState } from 'react'
import { useTranslation } from 'react-i18next' // i18n failed in storybook, therefore import react-i18next instead
import styled from 'styled-components'
import tw from 'twin.macro'
import Cropper from './Cropper'
import {
  COVER_IMAGE_API_CROPPED_WIDTH,
  COVER_IMAGE_API_CROPPED_HEIGHT,
} from '../_shared/ImageConstant'
import { useArticleContext } from '../_core'

function ImageEditor(props) {
  const {
    selectedImages,
    setSelectedImages,
    onImageEdit,
    handleImageFile,
    visibility,
    setVisibility,
  } = props
  const { t } = useTranslation('imageInput')
  const [cropResults, setCropResults] = useState([])
  const [tempCropPositions, setTempCropPositions] = useState([])
  const [drag, setDrag] = useState(false)
  const { updateImageIds, articleState } = useArticleContext()

  const closeLightBox = (e) => {
    if (e.target === e.currentTarget && !drag) {
      setVisibility(false)
      setTempCropPositions([])
      setCropResults([])
    }
    setDrag(false)
  }

  const saveChange = async () => {
    setVisibility(false)
    const croppedSize: Record<string, unknown> = {
      height: COVER_IMAGE_API_CROPPED_HEIGHT,
      width: COVER_IMAGE_API_CROPPED_WIDTH,
      fit: 'cover',
    }
    // 針對有被user移動位置的圖片裁切
    if (cropResults.length > 0) {
      for (const result of cropResults) {
        const body = { crop: result.crop, croppedSize }
        const image = selectedImages.find((val) => val.id === result.id)
        const tempCropPosition = tempCropPositions.find((position) => position.id === image.id)
        const cropResult = cropResults.find((result) => result.id === image.id)

        const payload = {
          id: result.id,
          body,
        }
        const handleImageFileArgs = {
          file: image,
          setSelectedFiles: setSelectedImages,
          id: image.id,
          onImageAction: onImageEdit,
          actionName: 'edit',
          payload,
          tempCropPosition,
          cropResult,
          croppedSize,
          updateImageIds,
          articleState,
        }
        handleImageFile({ ...handleImageFileArgs })
      }
    }

    setCropResults([])
  }

  return (
    visibility && (
      <OuterWrap onClick={closeLightBox}>
        <InnerWrap>
          <Header>
            <Hint>
              <div>
                <span className="edit">{t(['cropImage', '裁切照片'])}</span>
                <span className="drag">{t(['dragAndCrop', '拖曳調整裁切範圍'])}</span>
              </div>
            </Hint>
            <Action>
              <p className="cancel" onClick={closeLightBox}>
                {t(['cancel', '取消'])}
              </p>
              <p className="save-change" onClick={saveChange}>
                {t(['save', '儲存'])}
              </p>
            </Action>
          </Header>
          <Cropper
            selectedImages={selectedImages}
            setCropResults={setCropResults}
            tempCropPositions={tempCropPositions}
            setTempCropPositions={setTempCropPositions}
            setDrag={setDrag}
          />
        </InnerWrap>
      </OuterWrap>
    )
  )
}

const OuterWrap = styled.div`
  ${tw`flex items-center justify-center`}
  ${tw`fixed z-mask`}
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
`

const InnerWrap = styled.div`
  ${tw`rounded-lg`}
  background-color: rgba(255, 255, 255, 1);
  width: 768px;
  height: 485px;
`

const Header = styled.div`
  ${tw`flex items-center justify-between`}
  ${tw`box-border`}
  border-bottom: 1px solid #e6e6e6;
  padding: 16px;
  height: 72px;
`

const Hint = styled.div`
  ${tw`flex items-center `}
  .edit {
    ${tw`text-black`}
    ${tw`block`}
    font-size: 14px;
  }
  .drag {
    ${tw`text-gray-400`}
    ${tw`block`}
    font-size: 12px;
  }
`

const Action = styled.div`
  ${tw`flex items-center justify-center`}
  .cancel {
    ${tw`text-black`}
    ${tw`cursor-pointer`}
    font-size: 14px;
  }
  .save-change {
    ${tw`text-white`}
    ${tw`text-center`}
    ${tw`bg-primary-indigo`}
    ${tw`cursor-pointer`}
    ${tw`flex items-center justify-center`}
    font-size: 14px;
    width: 52px;
    height: 32px;
    border-radius: 24px;
    margin-left: 20px;
    line-height: 32px;
  }
`

export default ImageEditor
